import { JointGiftingApprovalStatus } from '@interfaces/gifting/gifting.interface';
import { GiftRecipientTypes, MultiSignerSignState, YesNoEmpty } from '@interfaces/models';
import { SpecIDFallback } from '@interfaces/models/spec-id-fallback.enum';

export interface GiftingRecipient {
  anonymousGift: YesNoEmpty;
  dtcNumber: string;
  type: GiftRecipientTypes;
  firm: string;
  name: string;
  accountNumber: string;
  transferAgentName?: string;
  streetAddress?: string;
  zipcode?: string;
  city?: string;
  state?: string;
  ssn?: string;
  dateOfBirth?: string;
}

export interface GiftingState {
  recipient: GiftingRecipient;
  jointGiftingApprovalStatus: JointGiftingApprovalStatus;
  totalGiftAmount: string;
  giftId?: string;
  signState?: MultiSignerSignState;
  specIDFallback: SpecIDFallback;
}
